import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/jobs/')({
  component: JobsIndexPage,
});

// NOT-297: the jobs index is a full-width Table/Board view rendered by the parent
// layout, so this index child has no detail pane and renders nothing. It used to
// `redirect` to the first job's detail to fill the old master-detail right pane —
// but once the detail became a full-page view (which hides the list), that
// redirect made `/dashboard/jobs` jump straight to a job with no list.
function JobsIndexPage() {
  return null;
}
